export const pgColleges = [
  {
    sno: 1,
    jnbId: "18887",
    name: "Sri Ramakrishna PG College",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9440243588",
    email: "drgrkreddy@hotmail.com"
  },
  {
    sno: 2,
    jnbId: "17378",
    name: "Sri Sankara's Degree College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9052172902",
    email: "sankarasug@gmail.com"
  },
  {
    sno: 3,
    jnbId: "21620",
    name: "The Adoni Arts & Science College",
    place: "Adoni",
    district: "Kurnool",
    phone: "9849057392",
    email: "adonicollege@gmail.com"
  },
  {
    sno: 4,
    jnbId: "23202",
    name: "Sri Sai M.B.A College",
    place: "Nandikotkur",
    district: "Nandyal",
    phone: "7013100961",
    email: "saimbandk@gmail.com"
  }
];
